import { endOfDay } from "../assessments/calendarDay.js";
import type { PersonInvolvement } from "../types/involvement.js";

/**
 * Whether an involvement already ends at the end of the UK calendar day given.
 * An ending to that day would move nothing, so it is refused: a later ending
 * made against the same view would otherwise still match, and replace the
 * first one's cause and reason unseen.
 */
export const isInvolvementEndingOn = ({
  involvement,
  day,
}: {
  involvement: Pick<PersonInvolvement, "endedAt">;
  day: string;
}): boolean => involvement.endedAt?.getTime() === endOfDay(day).getTime();
